import moment from 'moment';
import {
  fastPeriodNames,
  fastPeriodTexts,
} from '../../../../constants/choosePeriodTexts';

const { ago, last, current, next, ahead } = fastPeriodNames;

export const getFastPeriodsData = (view) => [
  {
    id: last,
    text: fastPeriodTexts[last][view],
    period: moment().subtract(1, view),
  },
  {
    id: current,
    text: fastPeriodTexts[current][view],
    period: moment(),
  },
  {
    id: next,
    text: fastPeriodTexts[next][view],
    period: moment().add(1, view),
  },
  {
    id: ago,
    text: fastPeriodTexts[ago][view],
    icon: 'fast-backward',
    iconPosition: 'left',
    period: moment().subtract(2, view),
  },
  {
    id: ahead,
    text: fastPeriodTexts[ahead][view],
    icon: 'fast-forward',
    iconPosition: 'right',
    period: moment().add(2, view),
  },
];
